import React from 'react';
import { GroupingModal } from './GroupingModal';
import GenericDialogue from 'src/components/Dialogue/Dialogue';

interface IGroupingOverlayProps {
  showGroupOverlay: boolean;
  setShowGroupOverlay: (show: boolean) => void;
  selectedServiceRequestIds: string[];
  existingGroups: any[];
  fetchDashboard: () => void;
  groupingPropertyId: string | null;
}

export const GroupingOverlay = ({
  showGroupOverlay,
  setShowGroupOverlay,
  selectedServiceRequestIds,
  existingGroups,
  fetchDashboard,
}: IGroupingOverlayProps) => {
  return (
    <GenericDialogue
      isOpen={showGroupOverlay}
      onClose={() => setShowGroupOverlay(false)}
      title="Grouping"
      maxWidth="50rem"
      maxHeight="80rem"
    >
      <GroupingModal
        serviceRequestIds={selectedServiceRequestIds}
        existingGroups={existingGroups}
        onClose={() => setShowGroupOverlay(false)}
        fetchDashboard={fetchDashboard}
        propertyId={null}
      />
    </GenericDialogue>
  );
};